<script setup lang="ts">
/**
 * Typography component that aims at styling text consistently.
 * @example
 * ```vue
 * <UeTypography contrastWithColor="primary">
 *   <p>This is a paragraph</p>
 * </UeTypography>
 * ```
 */
import { computed } from 'vue'
import { useDarkTextForColor } from '@lib/colors'

interface Props {
  /**
   * The color to contrast with.
   */
  contrastWithColor?: string
}

const props = defineProps<Props>()

const classList = computed(() => {
  const classes: string[] = []
  if (props.contrastWithColor) {
    if (!useDarkTextForColor(props.contrastWithColor)) {
      classes.push('text-white')
    }
  }
  return classes
})
</script>

<template>
  <div v-bind="$attrs" :class="classList">
    <slot />
  </div>
</template>
